// Draggable stickers — listeners attached only while dragging, not permanently
(function () {
  document.querySelectorAll('[data-sticker]').forEach((el) => {
    let sx, sy, px, py;

    const onMove = (e) => {
      const pt = e.touches ? e.touches[0] : e;
      el.style.left = (px + pt.clientX - sx) + 'px';
      el.style.top  = (py + pt.clientY - sy) + 'px';
    };

    const onUp = () => {
      el.classList.remove('dragging');
      window.removeEventListener('mousemove', onMove);
      window.removeEventListener('touchmove', onMove);
      window.removeEventListener('mouseup',   onUp);
      window.removeEventListener('touchend',  onUp);
    };

    const onDown = (e) => {
      e.preventDefault();
      const pt     = e.touches ? e.touches[0] : e;
      const r      = el.getBoundingClientRect();
      const parent = el.offsetParent.getBoundingClientRect();
      px = r.left - parent.left;
      py = r.top  - parent.top;
      sx = pt.clientX;
      sy = pt.clientY;
      el.classList.add('dragging');
      el.style.left = px + 'px';
      el.style.top  = py + 'px';
      // Attach move/up only for the duration of this drag
      window.addEventListener('mousemove', onMove, { passive: true });
      window.addEventListener('touchmove', onMove, { passive: false });
      window.addEventListener('mouseup',   onUp);
      window.addEventListener('touchend',  onUp);
    };

    el.addEventListener('mousedown',  onDown);
    el.addEventListener('touchstart', onDown, { passive: false });
  });
})();
